import { flexStyle, textStyle } from '@themes/mixins';
import styled from 'styled-components';

export const Root = styled.div`
  position: relative;
  width: 100%;
`;
export const FooterContainer = styled.div`
  ${flexStyle({
    align: 'center',
    justify: 'flex-start',
    direction: 'row',
    wrap: 'nowrap',
  })};
  position: relative;
  gap: 12px;
  height: 50px;
  padding: 0 16px;
  border: 1px solid ${({ theme }) => theme.colors.divider};
  border-top-left-radius: 4px;
`;

export const Copyright = styled.span`
  ${textStyle({
    color: 'textSecondary',
    lineHeight: 1,
    size: '12px',
    textAlign: 'center',
    weight: 400,
  })};
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const AppVersionTitle = styled.span`
  ${textStyle({
    color: 'textSecondary',
    lineHeight: 1,
    size: '12px',
    textAlign: 'left',
    weight: 400,
  })};
  margin-left: 4px;
`;
